module.exports = __webpack_public_path__ + "static/img/logo-NORTH-MELBOURNE.5cb2247.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-NORTH-MELBOURNE.svg
// module id = BTMN
// module chunks = 1